/* eslint-disable react/no-danger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-const */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
/* eslint-disable no-else-return */
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styled, { css } from "styled-components";
import axios from "axios";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import fetchConfig from "../../Constants/fetch";
import i18n, { changeLanguage, getLanguages } from '../../i18n'
import {
  LoginPageLeftSide,
  X,
  ViewPasswordIcon,
  HidePasswordIcon,
} from "../../Constants/assets";
import errorMessages from "../../Constants/ErrorMessages";
import {
  sendUserLoginData,
  checkRestoreGame,
  createNewGame,
  forgotPass,
} from "../../utils/global";

import { LanguageSelector, SavedGameDialog } from "../../components/index";
import { LoginChooseAccountPopup } from "../../components/LoginChooseAccountPopup/LoginChooseAccountPopup";
import { LoginDropdown } from "./LoginChooseInstructorField";

const cryptoJS = require("crypto-js");

const InnerContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  font-size: 0.875rem;
`;

const RightSideContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #EBECED;


  @media only screen and (max-width: 1150px) {
    & {
      flex: 1;
    }
  }

  ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            // height: 33%;
        }
    `}
`;
const ContentContainer = styled.div`
  width: 360px;
  place-self: center;
`;
const HeaderContainer = styled.div`
  height: 100px;
`;
const Title = styled.div`
  font-size: 2.625rem;
`;
const Paragraph = styled.div`
  color: ${(props) => props.theme.colors.gray};
`;
const FormContainer = styled.div``;
const FormLineContainer = styled.div`
  min-height: 6.8rem;
`;
const Label = styled.label`
  margin-left: 4px;
  ${props => props.block ? "display: block" : ""}
`;
const errorTextWrap = `
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.35;
`;
const ErrorContainer = styled.div`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.red};
  padding: 5px 0px 10px 4px;
  display: ${(props) => (props.isError ? "block" : "none")};
  ${errorTextWrap}
`;
const InvalidCreds = styled.div`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.red};
  padding: 5px 0px 0px 4px;
  display: ${(props) => (props.isError ? "block" : "none")};
  ${errorTextWrap}
`;
const EmptyMail = styled.div`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.red};
  padding: 5px 0px 0px 4px;
  display: ${(props) => (props.isError ? "block" : "none")};
  ${errorTextWrap}
`;
const EmptyPassword = styled.div`
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.red};
  padding: 5px 0px 0px 4px;
  display: ${(props) => (props.isError ? "block" : "none")};
  ${errorTextWrap}
`;
const Input = styled.input`
  width: 82%;
  height: 3.125rem;
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 4px;
  font-size: 16px;
  padding-left: 19px;
  ::-ms-reveal {
    display: none;
  }
`;
const Dropdown = styled.select`
  width: 18.75rem;
  height: 3.125rem;
  border: 1px solid ${(props) => props.theme.colors.gray};
  border-radius: 4px;
  font-size: 16px;
  padding-left: 19px;
  ::-ms-reveal {
    display: none;
  }
`;
const ResetCon = styled.button`
  width: max-content;
  padding: 0;
  border: 0;
  background: transparent;
`;
const ResetPass = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.darkGreen};
  cursor: pointer;
`;


const ButtonInput = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  width: 18.75rem;
  height: 3.125rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  :active {
    background: ${(props) => props.theme.colors.lightGray};
  }
  ${(props) =>
    props.clickedLogin && !props.showAccountPopup
      ? css`
          background: ${(componentProps) =>
          componentProps.theme.colors.lightGray};
        `
      : css`
          background: ${(componentProps) =>
          componentProps.theme.colors.darkGreen};
          cursor: pointer;
        `}
`;
const LinksContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  width: 83%;
  justify-content: space-between;
`
const ResetOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(0, 0, 0, .35);
`;
const ResetDialog = styled.div`
  position: relative;
  width: min(400px, 100%);
  padding: 32px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, .18);
`;
const ResetCloseButton = styled(IconButton)`
  position: absolute !important;
  top: 12px;
  right: 12px;
`;
const ResetTitle = styled.h2`
  margin: 18px 0 28px;
  font-size: 2rem;
  line-height: 1.15;
`;
const ResetForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const ResetInput = styled(Input)`
  width: 100%;
  box-sizing: border-box;
`;
const ResetSubmit = styled(ButtonInput)`
  width: 100%;
  margin-top: 8px;
`;
const TermsAndConditions = styled.div`
  text-decoration: underline;
  cursor: pointer;
`

const EyeIconContainer = styled.div`
  position: absolute;
  width: max-content;
  right: 21%;
  transform: translateY(-25%);
  height: 50px;
  display: flex;
  justify-content: flex-end;
  top: 50%;
`;


export default function Login({
  handleLogin,
  setPlayerEmail,
  playerEmail,
  askRestoreGame,
  handleReset,
  getArrayOfAccountsByEmail,
  onlyShowModal,
  toggleModal,
  gameEventId,
  gameCreationDateTime,
  checkZoomMessage,
  languagesList,
  currentLanguage,
  setCurrentLanguage,
  shortCutLanguage,
  setInstructorAndAccountId,
}) {
  const { t } = useTranslation();
  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [validationError, setValidationError] = useState(null);
  const [invalidCredsError, setInvalidCredsError] = useState(null);
  const [emptyMailError, setEmptyMailError] = useState(null);
  const [emptyPasswordError, setEmptyPasswordError] = useState(null);
  const [clickedLogin, setClickedLogin] = useState(false);
  const [loadingInterval, setloadingInterval] = useState(false);
  const [loadingButton, setLoadingButton] = useState(t('login.login_section.login_title'));
  const instructorsArray = useRef([]);

  const [showAccountFields, setShowAccountFields] = useState(false);
  const [showSavedGameDialog, setShowSavedGameDialog] = useState(false);
  const [loginInfo, setLoginInfo] = useState(null);

  let [selectedAccountId, setSelectedAccountId] = useState(null);
  let [selectedInstructorId, setSelectedInstructorId] = useState(null);

  const [accountsInformation, setAccountsInformation] = useState(false);
  const [modal, setmodal] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [lng, setLng] = useState(i18n.language);

  const [instructorError, setInstructorError] = useState('');
  const [accountError, setAccountError] = useState('');

  const emailRef = useRef(null);
  const accountRef = useRef(null);
  const instructorRef = useRef(null);
  const passwordRef = useRef(null);
  const intervalRef = useRef();


  useEffect(() => {
    const currentInterval = intervalRef.current;
    checkZoomMessage();
    return () => {
      if (currentInterval) {
        clearInterval(currentInterval);
      }
    };
  }, [i18n]);


  useEffect(() => {
    const fetchLanguages = async () => {
      const translationsData = await getLanguages();

      const languagesLists = Object.values(translationsData);

      setLanguages(languagesLists);
    };

    fetchLanguages();
  }, []);


  useEffect(() => {
    const handleLanguageChange = (languagee) => {
      setLng(languagee);
    };

    i18n.on('languageChanged', handleLanguageChange); // Listen to language changes

    return () => {
      i18n.off('languageChanged', handleLanguageChange); // Clean up listener
    };
  }, [i18n]);


  const userErrorMessages = {
    Password: t("login.login_section.error_messages.wrong_password"),
    /* The result in the line below would be 'networkError' */
    [errorMessages.NETWORK_ERROR]: t("login.login_section.error_messages.network_error"),
    validation: t("login.login_section.error_messages.inv_email_password"),
  };

  // FIXME: The function is built very poorly because the lack of time,
  // Needs fixing ASAP
  const styleErrorInput = (inputName) => {
    console.log("input name", inputName)
    if (!inputName) {
      emailRef.current.style.borderColor = "black";
      emailRef.current.style.outline = "black";
      emailRef.current.style.color = "black";

      passwordRef.current.style.borderColor = "black";
      passwordRef.current.style.outline = "black";
      passwordRef.current.style.color = "black";
    }

    if (inputName === "none") {
      emailRef.current.style.borderColor = "black";
      emailRef.current.style.outline = "black";
      emailRef.current.style.color = "black";

      passwordRef.current.style.borderColor = "black";
      passwordRef.current.style.outline = "black";
      passwordRef.current.style.color = "black";
    }

    if (inputName === "email") {
      // The error ocurred in the email input
      emailRef.current.style.borderColor = "red";
      emailRef.current.style.outline = "red";
      emailRef.current.style.color = "red";

      passwordRef.current.style.borderColor = "black";
      passwordRef.current.style.outline = "black";
      passwordRef.current.style.color = "black";
    } else if (inputName === "password") {
      // The error ocurred in the password input
      emailRef.current.style.borderColor = "black";
      emailRef.current.style.outline = "black";
      emailRef.current.style.color = "black";

      passwordRef.current.style.borderColor = "red";
      passwordRef.current.style.outline = "red";
      passwordRef.current.style.color = "red";
    } else if (inputName === "validation") {
      // The error ocurred in the password input
      emailRef.current.style.borderColor = "red";
      emailRef.current.style.outline = "red";
      emailRef.current.style.color = "red";

      passwordRef.current.style.borderColor = "red";
      passwordRef.current.style.outline = "red";
      passwordRef.current.style.color = "red";
    } else if (inputName === "mailEmpty") {
      emailRef.current.style.borderColor = "red";
      emailRef.current.style.outline = "red";
      emailRef.current.style.color = "red";
    } else if (inputName === "passwordEmpty") {
      passwordRef.current.style.borderColor = "red";
      passwordRef.current.style.outline = "red";
      passwordRef.current.style.color = "red";
    } else if (inputName === "accountEmpty") {
      accountRef.current.style.borderColor = "red";
      accountRef.current.style.outline = "red";
      accountRef.current.style.color = "red";
    } else if (inputName === "instructorEmpty") {
      instructorRef.current.style.borderColor = "red";
      instructorRef.current.style.outline = "red";
      instructorRef.current.style.color = "red";
    } else if (inputName === "mailFilled") {
      emailRef.current.style.borderColor = "black";
      emailRef.current.style.outline = "black";
      emailRef.current.style.color = "black";
    } else if (inputName === "passwordFilled") {
      passwordRef.current.style.borderColor = "black";
      passwordRef.current.style.outline = "black";
      passwordRef.current.style.color = "black";
    } else if (inputName === "accountFilled" && accountRef.current?.style) {
      accountRef.current.style.borderColor = "black";
      accountRef.current.style.outline = "black";
      accountRef.current.style.color = "black";
    } else if (inputName === "instructorFilled" && instructorRef.current?.style) {
      instructorRef.current.style.borderColor = "black";
      instructorRef.current.style.outline = "black";
      instructorRef.current.style.color = "black";
    }
  };

  const loadingButtonAnimation = () => {
    if (clickedLogin) {
      intervalRef.current = setInterval(() => {
        setLoadingButton(`${t('login.login_section.login_title')}.`);
        setTimeout(() => {
          setLoadingButton(`${t('login.login_section.login_title')}..`);
        }, 300);
        setTimeout(() => {
          setLoadingButton(`${t('login.login_section.login_title')}...`);
        }, 600);
      }, 900);
      return intervalRef.current;
      // setTimeout(()=>{clearInterval(x)}, 30000);
    }
    setLoadingButton(t('login.login_section.login_title'));
  };

  // TODO: This function needs refactoring, it's working but the code not so readable
  // Moved this function inside the Login component because we are changing the state in it
  const submitValidation = async (Email, Password, language, instructor = null) => {

    // if player has changed his email, he wants to login as another user, so the account selection is irrelevant.
    if (playerEmail !== emailInput) {
      setShowAccountFields(false);
      setSelectedAccountId(null);
      setSelectedInstructorId(null);
      instructorsArray.current = [];
    }
    setPlayerEmail(emailInput);

    // hashing
    setClickedLogin(true);
    const hash = cryptoJS.SHA256(Password);
    const encPassword = hash.toString(cryptoJS.enc.Hex);
    if (selectedInstructorId === null && instructorsArray.current?.length > 1) {
      setInstructorError(t('login.login_section.error_messages.empty_fields'));
      styleErrorInput("instructorEmpty");
      setClickedLogin(false);
      return;
    } else if (selectedInstructorId !== null) {
      setInstructorError("");
      styleErrorInput("instructorFilled");
    }
    if (selectedAccountId === null && instructorsArray.current?.[selectedInstructorId]?.accounts_json.length > 1) {
      setAccountError(t('login.login_section.error_messages.empty_fields'));
      styleErrorInput("accountEmpty");
      setClickedLogin(false);
      return;
    } else if (selectedAccountId !== null) {
      setInstructorError("");
      styleErrorInput("instructorFilled");
    }

    // hashing end
    const ValidationResult = await sendUserLoginData(
      {
        Email,
        Password,
        encPassword,
        accountValue: instructor ? (instructorsArray.current?.[selectedInstructorId].accounts_json[selectedAccountId].account_id) : null,
        instructor: instructor ? (instructorsArray.current?.[selectedInstructorId].accounts_json[selectedAccountId].instructor_id) : null,
      },
      gameEventId
    );
    // The validation result will be an object if theres an error
    if (ValidationResult.userId === "error" || typeof ValidationResult.errorCode === "object") {
      switch (ValidationResult.errorMessage) {
        // In case of network or server error
        // show to the user a normal error message
        case errorMessages.EXPIRED_USER:
          onlyShowModal(
            t('modals.account_not_active.info_title'),
            <>
              <p dangerouslySetInnerHTML={{ __html: t('modals.account_not_active.info_text').replace(/\n/g, '<br/>') }}></p>
            </>,
            t('modals.account_not_active.button1')
          );
          toggleModal();
          setClickedLogin(false);
          break;
        case errorMessages.NETWORK_ERROR:
        case errorMessages.SERVER_VALIDATION:
          setValidationError(userErrorMessages[ValidationResult.errorMessage]);
          setClickedLogin(false);
          break;
        // In case of front end validation error
        // show the user more specific error,
        // on which of the inputs is not valid
        case errorMessages.VALIDATION:
          if (typeof ValidationResult.errorCode === "object") {
            if (ValidationResult.errorCode.details[0].message !== undefined) {
              setClickedLogin(false);
              if (ValidationResult.errorCode.details[0].type === "string.empty" || ValidationResult.errorCode.details[0].type === "string.base") {
                if (emailInput === null || emailInput === "") {
                  setEmptyMailError(t('login.login_section.error_messages.empty_fields'));
                  styleErrorInput("mailEmpty");
                } else {
                  setEmptyMailError("");
                  styleErrorInput("mailFilled");
                }
                if (passwordInput === null || passwordInput === "") {
                  setEmptyPasswordError(t('login.login_section.error_messages.empty_fields'));
                  styleErrorInput("passwordEmpty");
                } else {
                  setEmptyPasswordError("");
                  styleErrorInput("passwordFilled");
                }
                if (selectedInstructorId === 0 && instructorsArray.current?.length > 1) {
                  setEmptyPasswordError(t('login.login_section.error_messages.empty_fields'));
                  styleErrorInput("passwordEmpty");
                } else {
                  setEmptyPasswordError("");
                  styleErrorInput("passwordFilled");
                }
                if (selectedAccountId === 0 && instructorsArray.current?.length > 1) {
                  setAccountError(t('login.login_section.error_messages.empty_fields'));
                  styleErrorInput("accountEmpty");
                } else {
                  setEmptyPasswordError("");
                  styleErrorInput("accountFilled");
                }
              } else {
                if (ValidationResult.errorCode.details[0].context.key === "Email") {
                  styleErrorInput("email");
                  setValidationError(t(ValidationResult.errorCode.details[0].message));
                }

                if (ValidationResult.errorCode.details[0].context.key === "Password") {
                  styleErrorInput("password");
                  setValidationError(
                    t(ValidationResult.errorCode.details[0].message)
                  );
                }
              }
            } else {
              if (emailInput === null || emailInput === "") {
                setEmptyMailError(t('login.login_section.error_messages.empty_fields'));
                styleErrorInput("mailEmpty");
              } else {
                setEmptyMailError("");
                styleErrorInput("mailFilled");
              }
              if (passwordInput === null || passwordInput === "") {
                setEmptyPasswordError(t('login.login_section.error_messages.empty_fields'));
                styleErrorInput("passwordEmpty");
              } else {
                setEmptyPasswordError("");
                styleErrorInput("passwordFilled");
              }
            }
            setClickedLogin(false);
            return false;
          }

          break;
        case "Password":
          setValidationError(userErrorMessages.validation);
          styleErrorInput("validation");
          setClickedLogin(false);
          break;
        case "Event has not started yet":
          setValidationError(t('login.login_section.error_messages.events.not_started'));
          styleErrorInput("none");
          setClickedLogin(false);
          break;
        case "Event has already ended":
          setValidationError(t('login.login_section.error_messages.events.ended'));
          styleErrorInput("none");
          setClickedLogin(false);
          break;
        case "Event not found":
          setValidationError(t('login.login_section.error_messages.events.not_found'));
          styleErrorInput("none");
          setClickedLogin(false);
          break;
        case "User is not in the event":
          setValidationError(t('login.login_section.error_messages.events.user_not_in_event'));
          styleErrorInput("none");
          setClickedLogin(false);
          break;
        case "User is not in the event but can play main game":
          setValidationError(t('login.login_section.error_messages.events.user_not_in_event_but_can_play'));
          styleErrorInput("none");
          setClickedLogin(false);
          break;
        default:
          break;
      }
      setClickedLogin(false);
      return false;
    }

    // check if user has multiple emails and accounts.
    if (instructorsArray.current.length == 0) {
      const instructors = await getArrayOfAccountsByEmail(Email);
      instructorsArray.current = instructors;

      // has multiple instructors
      // only possible in players
      console.log("got dat instructors", instructorsArray.current);
      if (instructors.length > 1) {
        // create a dummy account for initial instructor
        setClickedLogin(false);
        setSelectedInstructorId(null);
        setSelectedAccountId(null);
        setShowAccountFields(true);
        return;
      } else if (instructors.some(user => user.accounts_json?.length > 1)) {   // has multiple accounts but 1 instructor
        setClickedLogin(false);
        setSelectedInstructorId(0);
        setSelectedAccountId(null);
        setShowAccountFields(true);
        return;
      } else {  // if it only has 1 instructor, initialize default account and instructor
        // a little bit of a plaster, but they need to update immediately
        selectedAccountId = 0;
        selectedInstructorId = 0;
        setSelectedAccountId(0);
        setSelectedInstructorId(0);
      }
    }

    const instructor_id = instructorsArray.current[selectedInstructorId]?.accounts_json?.[selectedAccountId].instructor_id;
    const account_id = instructorsArray.current[selectedInstructorId]?.accounts_json?.[selectedAccountId].account_id;
    const fallbackPlayerName = Email?.split("@")?.[0] || Email;

    // Store the user information temporarily
    setLoginInfo({
      playerName: fallbackPlayerName,
      canPlayUntil: ValidationResult.canPlayUntil || null,
      userId: ValidationResult.userId,
      account_id,
      instructor_id,
      language
    });

    // Check if user has a saved game
    const checkForSavedGame = async (userId, instructorId, accountId) => {
      try {
        const response = await axios.get(`${fetchConfig.prefix}/checkSavedGame/${userId}`, {
          params: { instructorId, accountId }
        });
        return response.data;
      } catch (error) {
        console.error("Error checking saved game:", error);
        return { hasSavedGame: false, gameId: null };
      }
    };

    // Check for saved game and show dialog only if one exists
    const savedGameResult = await checkForSavedGame(ValidationResult.userId, instructor_id, account_id);
    if (savedGameResult.hasSavedGame) {
      setShowSavedGameDialog(true);
    } else {
      // No saved game - proceed directly to creating a new game
      const newGameResult = await createNewGame(
        ValidationResult.userId,
        gameEventId,
        gameCreationDateTime,
        account_id,
        instructor_id
      );
      setInstructorAndAccountId(instructor_id, account_id);

      // Check if game was restored and has state
      if (newGameResult.isRestored && newGameResult.state) {
        // Pass state to handleLogin
        handleLogin(fallbackPlayerName, ValidationResult.userId, newGameResult.gameId, language, newGameResult.state, ValidationResult.canPlayUntil);
      } else {
        // Normal new game
        handleLogin(fallbackPlayerName, ValidationResult.userId, newGameResult.gameId, language, null, ValidationResult.canPlayUntil);
      }
    }
    setClickedLogin(false);
  };

  const sendEmail = async (event) => {
    event.preventDefault();
    setResetLoading(true);
    try {
      await forgotPass({ Email: resetEmail, Language: i18n.language });
      setResetMessage(t('login.login_section.password_reset.email_sent'));
    } catch (error) {
      setResetMessage(error.response?.data?.error || t('login.login_section.password_reset.email_error'));
    } finally {
      setResetLoading(false);
    }
  };
  const url = window.location.href;
  const path = window.location.pathname;
  const [passwordShown, setPasswordShown] = useState(false);
  // Password toggle handler
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const handleContinueSavedGame = async () => {
    if (!loginInfo) return;

    // Call createNewGame without forceNewGame to restore saved game
    const newGameResult = await createNewGame(
      loginInfo.userId,
      gameEventId,
      gameCreationDateTime,
      loginInfo.account_id,
      loginInfo.instructor_id,
      false // forceNewGame = false to restore saved game
    );

    setInstructorAndAccountId(loginInfo.instructor_id, loginInfo.account_id);

    // Extract gameId from result object
    const gameId = newGameResult.gameId || newGameResult;
    // Check if game was restored and has state
    if (newGameResult.isRestored && newGameResult.state) {
      // Pass state to handleLogin for restored game
      handleLogin(loginInfo.playerName, loginInfo.userId, gameId, loginInfo.language, newGameResult.state, loginInfo.canPlayUntil);
    } else {
      // Fallback: normal game creation
      handleLogin(loginInfo.playerName, loginInfo.userId, gameId, loginInfo.language, null, loginInfo.canPlayUntil);
    }
  };

  const handleStartGame = async () => {
    if (!loginInfo) return;

    // Pass forceNewGame=true to delete saved game and create fresh game
    const newGameResult = await createNewGame(
      loginInfo.userId,
      gameEventId,
      gameCreationDateTime,
      loginInfo.account_id,
      loginInfo.instructor_id,
      true // forceNewGame = true to delete saved game
    );

    setInstructorAndAccountId(loginInfo.instructor_id, loginInfo.account_id);

    // Extract gameId from result object
    const gameId = newGameResult.gameId || newGameResult;
    // After deleting saved game, createNewGame should create a fresh game
    // so we don't need to check for isRestored
    handleLogin(loginInfo.playerName, loginInfo.userId, gameId, loginInfo.language, null, loginInfo.canPlayUntil);
  };

  return (
    <InnerContainer>
      <SavedGameDialog
        open={showSavedGameDialog}
        onClose={() => setShowSavedGameDialog(false)}
        onStartGame={handleStartGame}
        onContinueGame={handleContinueSavedGame}
      />
      {showForgotPassword && (
        <ResetOverlay>
          <ResetDialog role="dialog" aria-modal="true" aria-labelledby="reset-title">
            <ResetCloseButton type="button" onClick={() => setShowForgotPassword(false)} aria-label="Close">
              <CloseIcon fontSize="small" />
            </ResetCloseButton>
            <ResetTitle id="reset-title">{t('login.login_section.forgot_password_link')}</ResetTitle>
            {resetMessage ? <p role="status">{resetMessage}</p> : (
              <ResetForm onSubmit={sendEmail}>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="reset-email">{t('login.login_section.user_email')}</label>
                <ResetInput id="reset-email" type="email" value={resetEmail} onChange={(event) => setResetEmail(event.target.value)} required autoFocus />
                <ResetSubmit as="button" type="submit" disabled={resetLoading}>
                  {resetLoading ? t('login.login_section.password_reset.sending') : t('login.login_section.password_reset.send_link')}
                </ResetSubmit>
              </ResetForm>
            )}
          </ResetDialog>
        </ResetOverlay>
      )}
      <RightSideContainer>
        <ContentContainer>
          <LanguageSelector
            languages={languagesList}
            currentLanguage={currentLanguage}
            setCurrentLanguage={setCurrentLanguage}
            shortCutLanguage={shortCutLanguage}
            style={{ position: 'absolute', top: '50px', right: '50px' }}
          />
          <HeaderContainer>
            <Title>{t('login.login_section.login_title')}</Title>
          </HeaderContainer>
          <FormContainer>
            <form>
              <FormLineContainer>
                <Label>{t('login.login_section.user_email')}</Label>
                <br />
                <Input
                  ref={emailRef}
                  onChange={(event) => setEmailInput(event.target.value)}
                />
                <EmptyMail
                  style={{ width: "100%", maxWidth: "100%" }}
                  isError={emptyMailError !== null}
                >
                  {emptyMailError}
                </EmptyMail>
                <InvalidCreds
                  style={{ width: "100%", maxWidth: "100%" }}
                  isError={invalidCredsError !== null}
                >
                  {invalidCredsError}
                </InvalidCreds>
              </FormLineContainer>

              {showAccountFields && playerEmail == emailInput && instructorsArray.current?.length > 1 && (
                <FormLineContainer>
                  <Label>{t('login.login_section.instructor')}</Label>
                  <LoginDropdown
                    containerRef={instructorRef}
                    options={instructorsArray.current}
                    onChange={(currentlySelectedId) => {
                      setSelectedInstructorId(currentlySelectedId);

                      if (instructorsArray.current[currentlySelectedId].accounts_json.length > 1) {  // needs to select account
                        setSelectedAccountId(null);
                      } else {
                        setSelectedAccountId(0);
                      }
                    }}
                    accessIndex="instructor_fullname"
                  />
                  <EmptyPassword
                    style={{ width: "100%", maxWidth: "100%" }}
                    isError={instructorError !== null}
                  >
                    {instructorError}
                  </EmptyPassword>
                </FormLineContainer>
              )}

              {showAccountFields && playerEmail == emailInput && selectedInstructorId != null && instructorsArray.current?.[selectedInstructorId]?.accounts_json?.length > 1 && (
                <FormLineContainer>
                  <Label block="true">{t('login.login_section.account')}</Label>
                  <LoginDropdown
                    containerRef={accountRef}
                    options={instructorsArray.current?.[selectedInstructorId].accounts_json}
                    onChange={(currentlySelectedId) => {
                      setSelectedAccountId(currentlySelectedId);
                    }}
                    accessIndex="account_name"
                  />
                  <EmptyPassword
                    style={{ width: "100%", maxWidth: "100%" }}
                    isError={accountError !== null}
                  >
                    {accountError}
                  </EmptyPassword>
                </FormLineContainer>
              )}

              <FormLineContainer>
                <Label>{t('login.login_section.user_password')}</Label>
                <br />
                <div style={{ position: "relative" }}>
                  <Input
                    type={passwordShown ? "text" : "password"}
                    ref={passwordRef}
                    onChange={(event) => {
                      console.log("setting password value", event.target.value);
                      setPasswordInput(event.target.value)
                    }}
                    style={{
                      paddingRight: "30px", // Optional: Add padding to make space for the icon
                    }}
                  />
                  <EyeIconContainer>
                    <i>
                      {!passwordShown && (
                        <ViewPasswordIcon
                          style={{ cursor: "pointer" }}
                          onClick={togglePassword}
                        />
                      )}
                      {passwordShown && (
                        <HidePasswordIcon
                          style={{ cursor: "pointer" }}
                          onClick={togglePassword}
                        />
                      )}
                    </i>
                  </EyeIconContainer>
                </div>

                <EmptyPassword
                  style={{ width: "100%", maxWidth: "100%" }}
                  isError={emptyPasswordError !== null}
                >
                  {emptyPasswordError}
                </EmptyPassword>
                <ErrorContainer
                  style={{ width: "100%", maxWidth: "100%" }}
                  isError={validationError !== null}
                >
                  {validationError}
                </ErrorContainer>
                <ErrorContainer>
                  {t('login.login_section.error_messages.no_permission')}
                </ErrorContainer>
              </FormLineContainer>

              <ButtonInput
                clickedLogin={clickedLogin}
                accountsPopUp={showAccountFields}
                disabled={clickedLogin}
                onMouseDown={() => {
                  styleErrorInput("none");
                  setValidationError("");
                  setEmptyMailError("");
                  setEmptyPasswordError("");
                }}
                onClick={() => {
                  submitValidation(emailInput, passwordInput, selectedLanguage);
                }}
              >
                {t('login.login_section.login_title')}
              </ButtonInput>
              <LinksContainer>
                <ResetCon
                  type="button"
                  onClick={() => {
                    setResetMessage('');
                    setShowForgotPassword(true);
                  }}
                >
                  <ResetPass>{t('login.login_section.forgot_password_link')}</ResetPass>
                </ResetCon>
              </LinksContainer>
              <LinksContainer>
                <TermsAndConditions
                  onClick={() => {
                    window.location.href =
                      "https://terms.projectmanagementgame.pmzone.com/";
                  }}
                >{t('login.login_section.terms_and_conditions')}</TermsAndConditions>
              </LinksContainer>
            </form>
          </FormContainer>
        </ContentContainer>
      </RightSideContainer>
    </InnerContainer >
  );
}
